import type { DesignTokens } from '@vibesites/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Jackstraw-derived brand tokens.
 *
 * primary   — rust CTA color (#ac5125)
 * secondary — deep evergreen used by the header, footer, and dark headings (#042726)
 * accent    — warm taupe band behind the amenities highlight (#857c77)
 * surface   — light stone used by secondary buttons and quiet panels (#e5e1df)
 *
 * Property branding (property_primary_color / property_secondary_color) still
 * overrides primary / secondary at runtime.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    primary: '#ac5125',
    secondary: '#042726',
    accent: '#857c77',
    background: '#ffffff',
    surface: '#e5e1df',
    text: '#333333',
    textMuted: '#666666',
    textOnPrimary: '#ffffff',
    textOnSecondary: '#ffffff',
    border: '#d4d4d4',
    error: '#b42318',
    success: '#2f7a4b',
    warning: '#b7791f',
  },
  font: {
    ...defaultTokens.font,
    heading: "'Source Sans 3', 'Myriad Pro', 'Segoe UI', sans-serif",
    body: "'Barlow', 'Helvetica Neue', Arial, sans-serif",
    accent: "'Trirong', Georgia, serif",
  },
  fontSize: {
    ...defaultTokens.fontSize,
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '2.625rem',
    '6xl': '3.5rem',
  },
  radius: {
    ...defaultTokens.radius,
    none: '0',
    sm: '1px',
    md: '4px',
    lg: '8px',
    xl: '12px',
    full: '9999px',
  },
  shadow: {
    ...defaultTokens.shadow,
    sm: '0 1px 2px rgba(4, 39, 38, 0.06)',
    md: '0 4px 10px rgba(4, 39, 38, 0.10)',
    lg: '0 12px 28px rgba(4, 39, 38, 0.16)',
    xl: '0 24px 48px rgba(4, 39, 38, 0.22)',
  },
  transition: {
    ...defaultTokens.transition,
    fast: '150ms ease',
    normal: '250ms ease',
    slow: '500ms ease',
  },
};

export default tokens;
